import { Button, Modal } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { startGetEstatusAsistencia } from "../../../context/actions/detalleActions";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

export const AsignadoListening = () => {
  const dispatch = useDispatch();
  const { asistenciaID } = useParams();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const { estatusAsistencia } = useSelector((state) => state.detalleReducer);
  const reload = () => window.location.reload();

  useEffect(() => {
    const intervalId = setInterval(() => {
      dispatch(startGetEstatusAsistencia(asistenciaID));
    }, 20000);

    // función de limpieza
    return () => {
      clearInterval(intervalId);
    };
  }, [dispatch]);

  useEffect(() => {
    if (estatusAsistencia === 3) setIsModalOpen(true);
  }, [estatusAsistencia]);

  console.log("Estatus Asistencia:", estatusAsistencia);

  return (
    <Modal
      footer={[
        <Button size="small" danger onClick={() => setIsModalOpen(false)}>
          cerrar
        </Button>,
      ]}
      open={isModalOpen}
    >
      <div className="ModalProveedorAsignado">
        Este servicio ya fue asignado
      </div>
    </Modal>
  );
};
